;(function($) {
    function owlInitialize() {
		if ($(window).width() < 992) {
            $('.carousel-article').addClass('owl-carousel owl-theme');
            $('.carousel-article').owlCarousel({
				dots: true,
				slideTransition: "ease-in",
                dragEndSpeed: 50,
                responsive:{
                    0:{
                        items:1,
                    },
                    768:{
                        items:2
                    }
                }
		   });
		}else{
           $('.carousel-article').owlCarousel('destroy');
           $('.carousel-article').removeClass('owl-carousel owl-theme');
		}
    }

    function scrollTo() {
        $(".scrollTo").click(function() {
            var $this = $(this);
            var link = $this.attr("href");
            var position = $(link).offset().top;
            $("body,html").stop(true, true).animate({"scrollTop": position}, 500);
        });
    }

    function displayNavProgram() {
        var $window = $(window);
        var $nav = $(".nav-description-program");
        var description = $(".description-programm").first().offset().top;
        var last = $(".description-programm").last().next().offset().top;

        if ($window.scrollTop() > description && $window.scrollTop() < last) {
            $nav.addClass("fixed");
        } else {
            $nav.removeClass("fixed");
        }
    }

    function navigationSimulation() {
        $("a[aria-disabled=true]").on("click", function(event) {
            event.preventDefault();
            event.stopImmediatePropagation();
        });
    }

    $(document).ready(function(e) {
		owlInitialize();
	});
	
	$(window).resize(function() {
		owlInitialize();
	});

    $(document).ready(function() {
        //global utilities
        new WOW({
			animateClass: "is-animated"
        }).init();

        navigationSimulation();

        scrollTo();
        
        //zoom fancy
        $(".zoom").fancybox();

        $(".navbar-toggler").click(function() {
			$("html, body").toggleClass('fixed-body');
        });

        $(".btn-return-top").click(function() {
            $("body, html").stop(true, true).animate({"scrollTop" : 0}, 200);
        });

        $(window).scroll(function() {
            if($(window).scrollTop() > 500) {
                $(".btn-return-top").addClass("scroll");
            } else {
                $(".btn-return-top").removeClass("scroll");
            }
        });

        if($(".widget-push").length > 0) {
            $(".widget-push").owlCarousel({
                items: 1,
                dots: true,
                nav: false
            });
        }

        $(".footer-navigation .title").click(function() {
            var $this = $(this);
            
            $this.toggleClass("open");
            $this.next(".toggle-block").toggleClass("open");
        });

        $(".block-search legend").click(function() {
            $(this).closest(".block-search").toggleClass("open");
        });

         $(".block-search-map legend").click(function() {
            $(this).closest(".block-search-map").toggleClass("open");
        });

        $(".block-layered .title").click(function() {
            $(this).closest(".block-layered").toggleClass("open");
        });

        $(".widget .title-widget").click(function() {
            $(this).parent().toggleClass("open");
        });

        $('.select-custom').selectpicker({
            mobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent),
            width: '100%'
        });


        $("body.page-template-page-content").each(function() {
            $(".page-slider .owl-carousel").owlCarousel( {
                loop:true,
                margin:0,
                autoplay:true,
                nav:false,
                dots:false,
                items:1
            });
        });
        
        
        $("body.home").each(function() {
            $(".home-slider .owl-carousel").owlCarousel( {
                loop:true,
                margin:0,
                autoplay:true,
                nav:false,
                dots:false,
                items:1
            });
    
            $(".home-partners .owl-carousel").owlCarousel( {
                loop:true,
                margin:15,
                autoplay:true,
                nav:false,
                dots:false,
                items:5,
                center: true,
                responsive:{
                    0:{
                        items:2
                    },
                    768:{
                        items:2
                    },
                    992:{
                        items:5
                    }
                }
            });

            $(".testimonials-slider .owl-carousel").owlCarousel({
                loop:true,
                margin:0,
                autoplay:true,
                nav:false,
                dots:false,
                items:1
            });
        });

        if (! $('body').hasClass('single-real-estate')) {
            var $window = $(window);
            var $header = $('#header');

            $window.scroll(function() {
                if ($window.scrollTop() > 800) {
                    $header.addClass('fixed');
                } else {
                    $header.removeClass('fixed');
                }
            });
        }

        $("body.post-type-archive-real-estate").each(function() {
            $(this).find("form[name=search-layered]").each(function() {
                var $form = $(this);
                $form.find("input[type=checkbox], select").on("change", function() {
                    $form.submit();
                });
            });
        });
        $("body.single-real-estate").each(function() {
            var sliderprogram = $(".program-slider .owl-carousel");
            var sliderprogramthumbnail = $(".program-thumbnails-slider .owl-carousel");

            sliderprogram.owlCarousel({
                autoplay:true,
                nav:false,
                dots:false,
                items:1
            }).on('changed.owl.carousel', function(event) {
                sliderprogramthumbnail.trigger('to.owl.carousel', [event.item.index, 300, true]);
                sliderprogramthumbnail.find('.current').removeClass('current');
                sliderprogramthumbnail.find('.owl-item .item').eq(event.item.index).addClass('current');
            });

            sliderprogramthumbnail.owlCarousel({
                autoplay:true,
                nav: false,
                dots:false,
                margin:15,
                items: 5
            })
            .on('click', '.owl-item', function(event) {
                sliderprogram.trigger('to.owl.carousel', [$(event.target).parents('.owl-item').index(), 0, true]);
            });

            $(".project-slider .owl-carousel").owlCarousel( {
                loop:true,
                margin:0,
                autoplay:true,
                nav:false,
                dots:true,
                items:1
            });

            $('body').scrollspy({
                target: '#nav-description',
                offset: 120
            });

            displayNavProgram();

            $(window).scroll(function() {
                displayNavProgram();
            });

            $(".map-program").each(function() {
                var center = new google.maps.LatLng($(this).data("marker-latitude"), $(this).data("marker-longitude"));
                var map = new google.maps.Map(this, {
                    center: center,
                    zoom: 13,
                    disableDefaultUI: true
                });
                new google.maps.Marker({
                    position: center,
                    map: map,
                    icon: $(this).data("marker-icon")
                });
            });

        });

        $("body.page-template-about").each(function() {
            var $section = $("section.map");
            var $markers = $section.find("[data-markers]");
            var center = new google.maps.LatLng(47.218371, -1.553621000000021);
            var map = new google.maps.Map($section.find(".map-about")[0], {
                center: center,
                zoom: 13,
                disableDefaultUI: true
            });
            var boundaries = new google.maps.LatLngBounds();
            var markers = [];
            var icons = {
                new: $markers.find("[data-marker-area=marker-blue]").attr("src"),
                ancient: $markers.find("[data-marker-area=marker-green]").attr("src")
            };
            $markers.find("span").each(function() {
                var position = new google.maps.LatLng($(this).data("marker-latitude"), $(this).data("marker-longitude"));
                var marker = new google.maps.Marker({
                    position: position,
                    map: map,
                    icon: icons.new
                });
                var info = new google.maps.InfoWindow({
                    content: $(this).html()
                });
                google.maps.event.addListener(marker, 'click', function() {
                    info.open(map, marker);
                });
                boundaries.extend(position);
                markers.push(marker);
                
            });
            
            if (!markers.length) {
                map.setCenter(center);
            } else {
                map.fitBounds(boundaries);
            }
            if (map.getZoom() > 15) {
                map.setZoom(15);
            }
        });

        $("body.page-template-contact").each(function() {
            var $section = $("section.map");
            var $markers = $section.find("[data-markers]");
            var center = new google.maps.LatLng(47.218371, -1.553621000000021);
            var map = new google.maps.Map($section.find(".map-contact")[0], {
                //center: center,
                zoom: 15,
                disableDefaultUI: true
            });
            var boundaries = new google.maps.LatLngBounds();
            var markers = [];
            var icons = {
                new: $markers.find("[data-marker-area=marker-blue]").attr("src"),
                ancient: $markers.find("[data-marker-area=marker-green]").attr("src")
            };
            $markers.find("span").each(function() {
                var position = new google.maps.LatLng($(this).data("marker-latitude"), $(this).data("marker-longitude"));
                var marker = new google.maps.Marker({
                    position: position,
                    map: map,
                    title: $(this).text(),
                    icon: icons.new
                });
                //boundaries.extend(position);
                markers.push(marker);
                map.setCenter(position);
            });

            /*if (markers.length == 1) {
                map.setCenter(position);
            }*/

            //map.setCenter(center);
            //map.setZoom(9);

            /* if (!markers.length) {
                map.setCenter(center);
            }else {
                map.fitBounds(boundaries);
            }
            if (map.getZoom() > 15) {
                map.setZoom(15);
            }*/
        });

        $("body.page-template-search-map").each(function() {
            var $overview = $('div.result-search-map').hide();
            $overview.find("span.button-close").on("click", function() {
                $overview.toggle();
            });
            var center = new google.maps.LatLng(47.218371, -1.553621000000021);
            var map = new google.maps.Map(document.getElementById('map'), {
                center: center,
                zoom: 13,
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false

            });
            var icons = {
                new: $overview.find("[data-marker-area=marker-blue]").attr("src"),
                ancient: $overview.find("[data-marker-area=marker-green]").attr("src")
            };
            var markers = [];
            $("form[name=form-map]").on("submit", function(event) {
                event.preventDefault();
                $.ajax({
                    url: document.location.href,
                    method: "POST",
                    data: $(this).serialize(),
                    success: function(data) {
                        if (data.success) {
                            $.each(markers, function() {
                                this.setMap(null);
                            });
                            markers = [];
                            var boundaries = new google.maps.LatLngBounds();
                            $.each(data.markers, function() {
                                var post = this;
                                var position = new google.maps.LatLng(post.latitude, post.longitude);
                                var marker = new google.maps.Marker({
                                    position: position,
                                    map: map,
                                    title: post.title,
                                    icon: icons[post.kind]
                                });
                                marker.addListener("click", function() {
                                    $overview.show();
                                    $overview.find("[data-marker-area=image]").html(post.image);
                                    $overview.find("[data-marker-area=title]").html(post.title);
                                    $overview.find("[data-marker-area=room-minimum]").text(post.rooms.min);
                                    $overview.find("[data-marker-area=room-maximum]").text(post.rooms.max);
                                    $overview.find("[data-marker-area=price-minimum]").text(post.price.min);
                                    $overview.find("[data-marker-area=price-maximum]").text(post.price.max);
                                    $overview.find("[data-marker-area=district]").text(post.district);
                                    $overview.find("[data-marker-area=permalink]").attr("href", post.permalink);
                                });
                                boundaries.extend(position);
                                markers.push(marker);
                            });
                            if (!markers.length) {
                                map.setCenter(center);
                            } else {
                                map.fitBounds(boundaries);
                            }
                            if (map.getZoom() > 15) {
                                map.setZoom(15);
                            }
                        }
                    }
                })
            });
            $("form[name=form-map]").trigger("submit");
        });


    });

    window.initMap = function() {
        google.maps.event.addDomListener(window, 'load', function() {
            $(document).trigger("gmap");
        });
    }
	
})(jQuery);